import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20panoramic%20view%20of%20modern%20Asian%20city%20skyline%20with%20warm%20golden%20sunset%20gradient%2C%20soft%20atmospheric%20haze%2C%20abstract%20geometric%20patterns%20blending%20with%20architecture%2C%20elegant%20minimalist%20digital%20art%20style%2C%20warm%20amber%20and%20coral%20tones%2C%20no%20text%20or%20logos&width=1800&height=900&seq=hero-bg-asia-01&orientation=landscape"
        alt="亚洲在线 - 亚洲城市天际线"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center w-full px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs md:text-sm font-medium mb-5 md:mb-6">
          探索亚洲 · 连接无限可能
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white text-center mb-4 md:mb-5 leading-tight">
          亚洲在线
        </h1>
        <p className="text-base md:text-xl text-white/80 text-center max-w-xl md:max-w-2xl mb-6 md:mb-8 leading-relaxed">
          亚洲最全在线服务平台，汇聚亚洲各地优质资源与内容，提供便捷、安全、高效的在线体验。无论您身处亚洲何地，亚洲在线都能满足您的多元需求。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <Link
            to="/category/all"
            className="px-7 py-3 bg-primary-500 text-white text-sm md:text-base font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 bg-white/10 backdrop-blur-sm text-white text-sm md:text-base font-medium rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-10 md:mt-12 flex items-center gap-8 md:gap-12">
          {[
            { value: '500万+', label: '活跃用户' },
            { value: '10万+', label: '优质内容' },
            { value: '30+', label: '覆盖国家' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-xl md:text-2xl font-bold text-white">{stat.value}</p>
              <p className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}